import { SET_TOKEN, CLEAR_TOKEN, SET_REFRESH_TOKEN } from './mutations'
import { token } from "@/api"

const key = "jwt"

let user = {
  state: {
    token: null,
    refresh_token: null,
    detail: null,
  },
  mutations: {
    [SET_TOKEN] (state, token) {
      state.token = token
      state.detail = token ? JSON.parse(atob(token.split('.')[1])) : null
    },
    [SET_REFRESH_TOKEN] (state, token) {
      state.refresh_token = token
    },
    [CLEAR_TOKEN] (state) {
      state.token = null
      state.refresh_token = null
      state.detail = null
    }
  },
  actions: {
    login({ commit }, options) {
      return new Promise((resolve, reject) => {
        token.get(options.username, options.password).then((token) => {
          commit(SET_TOKEN, token.access)
          commit(SET_REFRESH_TOKEN, token.refresh)
          resolve()
        }).catch(err => reject(err))
      })
    },
    logout({ commit }) {
      commit(CLEAR_TOKEN)
    },
    refresh({ commit, state }) {
      return token.refresh(state.refresh_token).then((token) => {
        commit(SET_TOKEN, token.access)
        return token
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/user/index.js